/**
 * List of constants required for ensighten tagging, we will be using on page level components to update jcpDl object
 */
const constants = {
    WELCOME_PAGE_ID: 'account',
    PAGE_NAME: 'my account',
    siteSection: {
        HOME: 'account',
    },
};

export default constants;
